import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=db844a3c&scoped=true&"
import script from "./startPage.vue?vue&type=script&lang=js&"
export * from "./startPage.vue?vue&type=script&lang=js&"
import style0 from "./startPage.vue?vue&type=style&index=0&id=db844a3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db844a3c",
  null
  
)

component.options.__file = "startPage.vue"
export default component.exports